import { mapActions } from "vuex";

export const companyListsMixin = {
  data() {
    return {
      companies: [],
    };
  },

  computed: {
    mainHeaders() {
      return [
        {
          text: this.$i18n.t("Name"),
          align: "left",
          value: "name",
          width: "45%",
        },
        {
          text: this.$i18n.t("Email"),
          align: "left",
          value: "email",
          width: "30%",
        },
        {
          text: this.$i18n.t("Status"),
          align: "left",
          value: "status",
          width: "25%",
        },
      ];
    },
  },

  methods: {
    ...mapActions(["fetchAllCompanies"]),

    async getAllCompanies(queryParams = null) {
      this.loading = true;
      try {
        let companies = await this.fetchAllCompanies(queryParams);
        if (companies.data) {
          companies.data.forEach(company => {
            this.setCompanyStatus(company);
          });
          this.companies = companies.data;
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
        this.$nextTick(() =>
          this.updateLocalPagination(this.paginationFromParent)
        );
      }
    },
    getCompanyRowsFromLocalStorage(id) {
      let rows = parseInt(localStorage.getItem(id));
      if (rows) {
        return rows;
      } else {
        return 15;
      }
    },
    setCompanyRowsOnLocalStorage(id, rows) {
      localStorage.setItem(id, rows);
    },
    setCompanyStatus(company) {
      if (company) {
        company.status = company.status ? "active" : "inactive";
      }
    },

    isActive(status) {
      return status === "active" || status === true;
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/management/companyListsMixin.js